var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { ACCOUNT, FRANCHISOR } from '@/stores/defs';
import offersMixin from '@Mixin/offersMixin';
import menuItemMixin from '@Mixin/menuItemMixin';
import { isArray } from 'lodash';
var loyaltyMixin = {
    mixins: [
        offersMixin,
        menuItemMixin,
    ],
    computed: __assign({}, mapGetters({
        loyaltyPoints: ACCOUNT.GET_LOYALTY,
        franchisor: FRANCHISOR.GET_FRANCHISOR
    }), { canUseLoyaltyPoints: function () {
            return (this.franchisor.loyaltyPointsPerReward <= this.loyaltyPoints);
        },
        rewardsPerPoints: function () {
            return this.loyaltyPoints / this.franchisor.loyaltyPointsPerReward;
        },
        points: function () {
            var canUseLoyaltyPoints = this.canUseLoyaltyPoints;
            var calculatedPoints = Math.floor(this.rewardsPerPoints);
            var itemsAvailable = (canUseLoyaltyPoints) ? calculatedPoints : 0;
            return {
                available: 1 <= itemsAvailable,
                itemsAvailable: itemsAvailable,
                pointsNeeded: this.calculatePointsNeeded()
            };
        },
        displayLoyalty: function () {
            var points = this.loyaltyPoints;
            return (points).toLocaleString();
        },
        getLoyaltyPointsString: function () {
            return Math.round(this.loyaltyPoints).toLocaleString();
        } }),
    methods: {
        calculatePointsNeeded: function () {
            var pointsPerReward = this.franchisor.loyaltyPointsPerReward;
            if (this.canUseLoyaltyPoints) {
                return Math.ceil(this.rewardsPerPoints) * pointsPerReward - this.loyaltyPoints;
            }
            return pointsPerReward - this.loyaltyPoints;
        },
        getItemRouteIfAvailable: function (offerCoupon) {
            var items = offerCoupon.items;
            if (!items || !isArray(items)) {
                return;
            }
            var item = items[0];
            var itemId = item.asset_id || item.id;
            var routeItem = {
                id: itemId,
            };
            var route = this.getItemRoute(routeItem);
            this.offersForUser();
            this.setApplyOffer(offerCoupon);
            this.$router.push(route);
            this.$modal.hide('contentModal');
        }
    },
};
export default loyaltyMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/loyaltyMixin.ts
// module id = 4k3Q
// module chunks = 18